import { render, staticRenderFns } from "./Soja2022AreasProtegidasParaguai.vue?vue&type=template&id=07a6be12&scoped=true&lang=pug"
import script from "./Soja2022AreasProtegidasParaguai.vue?vue&type=script&lang=js"
export * from "./Soja2022AreasProtegidasParaguai.vue?vue&type=script&lang=js"
import style0 from "./Soja2022AreasProtegidasParaguai.vue?vue&type=style&index=0&id=07a6be12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6be12",
  null
  
)

export default component.exports